import moment from 'moment'
import i18n from '@/i18n'
import { utcToLocalDate } from '@/utils/DateFormatter.js'

export const sameAccountCertification = (a, b) => {
  if (!a || !b) return false
  if (a.accountCertificationId != null || b.accountCertificationId != null) return a.accountCertificationId === b.accountCertificationId
  if (a.localId != null || b.localId != null) return a.localId === b.localId
  return a === b
}

export const accountCertificationLabel = certification => certification?.certificateNumber
  ? `${certification.name} #${certification.certificateNumber}`
  : certification?.name ?? ''

export const isBasisExpired = certification => !!certification?.basisExpirationDate &&
  moment.utc(certification.basisExpirationDate).isSameOrBefore(moment.utc())

export const basisCertificationText = certification => {
  const parts = [certification.basisAccountName, certification.basisCertificationName]
  if (certification.basisCertificateNumber) parts.push(`#${certification.basisCertificateNumber}`)
  if (certification.basisExpirationDate) {
    parts.push(`${isBasisExpired(certification) ? i18n.t('expiredOn') : i18n.t('expiresOnVerbatim')} ${utcToLocalDate(certification.basisExpirationDate)}`)
  }
  return parts.filter(Boolean).join(' · ')
}

// Files uploaded before account certifications had their own identity live under the certification type id.
// That folder is only trusted while the account holds one certification of the type and no sibling's own id shadows it.
export const certificationFilePolicyIds = (certification, siblings) => {
  if (!certification) return []
  const ids = []
  if (certification.accountCertificationId != null) ids.push(certification.accountCertificationId)
  const others = (siblings ?? []).filter(c => c && !sameAccountCertification(c, certification))
  const legacyFolderUsable = certification.certificationId != null &&
    !others.some(c => c.certificationId === certification.certificationId || c.accountCertificationId === certification.certificationId)
  if (legacyFolderUsable) ids.push(certification.certificationId)
  return ids.map(String)
}

export const findCertificationFile = (files, certification, siblings) => {
  for (const policyId of certificationFilePolicyIds(certification, siblings)) {
    const file = files?.find(f => String(f?.policyId) === policyId)
    if (file) return file
  }
  return undefined
}
